// redux/dealerModalDispatcher.js
import { HIDE_ADD_DEALER_MODAL, SHOW_ADD_DEALER_MODAL } from "../../constants/actions";

// Action Creators
export const showAddDealerModal = () => ({
  type: SHOW_ADD_DEALER_MODAL,
});

export const hideAddDealerModal = () => ({
  type: HIDE_ADD_DEALER_MODAL,
});
